module.exports = __webpack_public_path__ + "static/media/facebook-logo.cf73f1c1.svg";